import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {KeyboardWizardPage} from "./keyboardWizardTypes";

interface IKeyboardWizard {
  activeDeviceId: string | undefined;
  activeDeviceName: string | undefined;
  canShowInputDetectedFromWrongDeviceModal: boolean;
  currentPage: KeyboardWizardPage,
  deviceToConfigureId: string | undefined;
  deviceToConfigureName: string | undefined;
  highestNote: number | null;
  isOpen: boolean;
  lowestNote: number | null;
  showInputDetectedFromWrongDeviceModal: boolean;
}

const initialState: IKeyboardWizard = {
  activeDeviceId: undefined,
  activeDeviceName: undefined,
  canShowInputDetectedFromWrongDeviceModal: true,
  currentPage: KeyboardWizardPage.ChooseDevice,
  deviceToConfigureId: undefined,
  deviceToConfigureName: undefined,
  highestNote: null,
  isOpen: false,
  lowestNote: null,
  showInputDetectedFromWrongDeviceModal: false
};

export const keyboardWizardSlice = createSlice({
  name: 'keyboardWizard',
  initialState,
  reducers: (create) => ({
    activeDeviceReducer: create.reducer((state, action: PayloadAction<{activeDeviceId: string | undefined, activeDeviceName: string | undefined}>) => {
      state.activeDeviceId = action.payload.activeDeviceId;
      state.activeDeviceName = action.payload.activeDeviceName;
    }),
    canShowInputDetectedFromWrongDeviceModalReducer: create.reducer((state, action: PayloadAction<{canShow: boolean}>) => {
      state.canShowInputDetectedFromWrongDeviceModal = action.payload.canShow;
    }),
    currentPageReducer: create.reducer((state, action: PayloadAction<{currentPage: KeyboardWizardPage}>) => {
      state.currentPage = action.payload.currentPage;
    }),
    deviceToConfigureIdReducer: create.reducer((state, action: PayloadAction<{deviceToConfigureId: string | undefined}>) => {
      state.deviceToConfigureId = action.payload.deviceToConfigureId;
    }),
    deviceToConfigureNameReducer: create.reducer((state, action: PayloadAction<{deviceToConfigureName: string | undefined}>) => {
      state.deviceToConfigureName = action.payload.deviceToConfigureName;
    }),
    isOpenReducer: create.reducer((state, action: PayloadAction<{isOpen: boolean}>) => {
      state.isOpen = action.payload.isOpen;
    }),
    highestNoteReducer: create.reducer((state, action: PayloadAction<{note: number}>) => {
      state.highestNote = action.payload.note;
    }),
    lowestNoteReducer: create.reducer((state, action: PayloadAction<{note: number}>) => {
      state.lowestNote = action.payload.note;
    }),
    resetReducer: create.reducer((state) => {
      state.deviceToConfigureId = initialState.deviceToConfigureId;
      state.deviceToConfigureName = initialState.deviceToConfigureName;
      state.currentPage = initialState.currentPage;
      state.lowestNote = initialState.lowestNote;
      state.highestNote = initialState.highestNote;
    }),
    showInputDetectedFromWrongDeviceModalReducer: create.reducer((state, action: PayloadAction<{show: boolean}>) => {
      state.showInputDetectedFromWrongDeviceModal = action.payload.show;
    }),
  }),
  selectors: {
    activeDeviceIdSelector: (state: IKeyboardWizard) => state.activeDeviceId,
    activeDeviceNameSelector: (state: IKeyboardWizard) => state.activeDeviceName,
    canShowInputDetectedFromWrongDeviceModalSelector: (state: IKeyboardWizard) => state.canShowInputDetectedFromWrongDeviceModal,
    currentPageSelector: (state: IKeyboardWizard) => state.currentPage,
    deviceToConfigureIdSelector: (state: IKeyboardWizard) => state.deviceToConfigureId,
    deviceToConfigureNameSelector: (state: IKeyboardWizard) => state.deviceToConfigureName,
    highestNoteSelector: (state: IKeyboardWizard) => state.highestNote,
    isOpenSelector: (state: IKeyboardWizard) => state.isOpen,
    lowestNoteSelector: (state: IKeyboardWizard) => state.lowestNote,
    showInputDetectedFromWrongDeviceModalSelector: (state: IKeyboardWizard) => state.showInputDetectedFromWrongDeviceModal,
  }
});

export const keyboardWizardReducer = keyboardWizardSlice.reducer;